module.exports = __webpack_public_path__ + "img/01d.f9c9ae33.svg";